import {atom} from 'jotai'

export const logoAtom = atom({})